import { normalizeAccountName } from '../helpers/normalizeAccountName.ts'

export type AccountIconKey = 'invoicing' | 'consumption' | 'people' | 'otherExpenses' | 'depreciation' | 'bonus'

export type PreviaSemanalPayloadField =
  | 'billingAmount'
  | 'consumptionAmount'
  | 'peopleAmount'
  | 'otherExpensesAmount'
  | 'depreciationAmount'
  | 'bonusAmount'

export interface AccountConfigProps {
  key: AccountIconKey
  normalizedName: string
  payloadField: PreviaSemanalPayloadField
}

export const ACCOUNTS_CONFIG: AccountConfigProps[] = [
  { key: 'invoicing', normalizedName: 'faturamento', payloadField: 'billingAmount' },
  { key: 'consumption', normalizedName: 'consumo', payloadField: 'consumptionAmount' },
  { key: 'people', normalizedName: 'pessoal', payloadField: 'peopleAmount' },
  { key: 'otherExpenses', normalizedName: 'outras despesas', payloadField: 'otherExpensesAmount' },
  { key: 'depreciation', normalizedName: 'depreciacao', payloadField: 'depreciationAmount' },
  { key: 'bonus', normalizedName: 'bonificacao', payloadField: 'bonusAmount' }
]

export const findAccountConfig = (accountName: string): AccountConfigProps | undefined => {
  const normalized = normalizeAccountName(accountName)

  return ACCOUNTS_CONFIG.find((config) => config.normalizedName === normalized)
}
